import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { fetchCentralisedPlansData } from "../../../redux/reducers/dropdownApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";

const MappedGyms = ({ userInfoData, rowData, callFunction }) => {
  const dispatch = useDispatch();
  const { centralisedPlans, loading, error } = useSelector(
    (state) => state.dropdown
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const filters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    package_details: rowData?.uid || "",
  };

  const fetchData = () => {
    dispatch(
      fetchCentralisedPlansData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const endpoint = "/plan/delete";
          const response = await dispatch(
            commonPostPutApi({
              method: "PUT",
              endpoint: endpoint,
              payload: filter,
              token: userInfoData?.token,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
            fetchData();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error?.message || error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (filters.package_details) {
      fetchData();
    }
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (!loading && !error && centralisedPlans?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: centralisedPlans.data,
        pagination:
          centralisedPlans?.pagination?.length > 0
            ? centralisedPlans.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [loading, error, centralisedPlans]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.gym_name || "NA"}</span>;
      },
    },
    {
      dataField: "uid",
      text: "plan name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.plan_name || "NA"} ({row?.duration || 0} Days)
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn icon delete"
            onClick={() => {
              const filters = {
                uid: row?.uid || "",
              };
              handleDelete(filters, row);
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none">
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
      {loading ? (
        <ReactVortoxSpinner />
      ) : allDatas?.allData?.length > 0 ? (
        <PaymentLinkTable
          tableData={allDatas?.allData}
          tableColumns={tbColumns}
          tablePagination={allDatas?.pagination}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      ) : (
        <div className="noDataFoundContainer">
          <p>No mapped gyms found.</p>
        </div>
      )}
    </div>
  );
};

export default MappedGyms;
